import bootLayout from 'static/script/app/boot/boot-layout';
import CartService from 'static/script/app/data/cart-service';
import CartMerchantUI from 'static/script/app/ui/cart/cart-merchant-ui';
import CartOverviewUI from 'static/script/app/ui/cart/cart-overview-ui';
import CartOrderRowUI from 'static/script/app/ui/cart/cart-order-row-ui';

export default initData => {
    bootLayout(initData);
    CartService.attachTo(document);
    CartMerchantUI.attachTo('.view-cart-merchant');
    CartOverviewUI.attachTo('.view-cart');
    CartOrderRowUI.attachTo('[data-view-cart-item]');
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/cart-overview.js